/**
 * MultiAlert.jsx
 * Created by michaelbray on 8/6/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../../sharedComponents/icons/Icons';
import DisplayHtmlContent from '../../sharedComponents/DisplayHtmlContent';
import * as StringHelper from '../../../helpers/stringHelper';


export default class MultiAlert extends React.PureComponent {
    static propTypes = {
        alertClassName: PropTypes.string,
        alertIcon: PropTypes.node,
        alertTitle: PropTypes.string,
        alerts: PropTypes.array
    };

    static defaultProps = {
        alertClassName: "",
        alertIcon: null,
        alertTitle: "",
        alerts: []
    };

    constructor(props) {
        super(props);

        const locationType = this.getLocationType(props.alerts);

        this.state = {
            locationType,
            visibility: false
        };
    }

    componentDidUpdate(prevProps) {
        const { alerts } = this.props;

        if (alerts !== prevProps.alerts) {
            const locationType = this.getLocationType();

            this.setState({
                locationType
            });
        }
    }

    getLocationType = (alerts = this.props.alerts) => {
        return alerts.length > 1 && alerts[0].location_type
            ? alerts[0].location_type
            : 'area';
    }

    toggleVisibility = () => {
        this.setState((prevState) => {
            return {
                visibility: !prevState.visibility
            };
        });
    }

    render() {
        return (
            <div className={`rec-mgs-is-multi-line ${this.props.alertClassName}`} role="banner" aria-labelledby="alertHeading">
                <div className="rec-msg">
                    <div className="rec-msg-text" id="alertHeading">
                        <div className="rec-msg-text-type">
                            <div className="rec-alerts-notification-icon">
                                {this.props.alertIcon}
                            </div>
                            <strong>
                                {this.props.alertTitle}
                            </strong>
                        </div>
                        <span>
                            There {StringHelper.pluralize(this.props.alerts, 'is', 'are')}{' '}
                            <strong>
                                {this.props.alerts.length} {StringHelper.pluralize(this.props.alerts, 'notification', 'notifications')}
                            </strong> for this {this.state.locationType}
                        </span>
                    </div>
                    <button onClick={this.toggleVisibility} aria-expanded={this.state.visibility}>
                        {this.state.visibility ? <Icons.IconChevronUp /> : <Icons.IconChevronDown />}
                        <span className="rec-msg-btn-text">
                            {this.state.visibility ? 'Hide' : 'Show'} Notification{StringHelper.pluralize(this.props.alerts, '', 's')}
                        </span>
                    </button>
                </div>

                {this.state.visibility && (
                    <div className="rec-msg-multi-line-wrap">
                        <div className="rec-msg-text-content">
                            <ul>
                                {
                                    this.props.alerts.map((alert) => (
                                        <li key={alert.body}>
                                            <DisplayHtmlContent html={alert.body} />
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}